<template>
  <div id="app" style="background-color: var(--bg-back)">
    <!-- 根据路由判断是否显示 LeftBar -->
    <LeftBar ref="LeftBar_c" v-if="!isOauthLoading" />
    <!-- <LeftBar ref="LeftBar_c" @navigate-to-micro="handleNavigateToMicro" /> -->
    <!-- 路由组件显示锚点 start -->
    <div class="app-shell">
      <main class="app-main">
        <transition mode="out-in">
          <template v-if="$route.meta.keepAlive && !showMicroApp">
            <keep-alive>
              <router-view class="view" />
            </keep-alive>
          </template>
          <template v-else-if="!showMicroApp">
            <router-view class="view" />
          </template>
        </transition>
        <!-- 路由组件显示锚点 end -->

        <!-- 微应用容器 -->
        <div v-show="showMicroApp" id="subapp-container" class="micro-app-container"></div>
      </main>

      <footer class="site-footer">©2017-2027 江苏畅想之星信息技术有限公司 版权所有 苏IPC备13023325号-1</footer>
    </div>
  </div>
</template>

<script>
// import HelloWorld from './components/HelloWorld.vue'
import LeftBar from "@/components/LeftBar.vue";
import { loadMicroApp } from "qiankun";

export default {
  name: "App",
  components: {
    LeftBar,
  },
  data() {
    return {
      showMicroApp: false,
      currentMicroApp: null,
      microAppInstance: null,
      activeAppName: "",
      appLock: Promise.resolve(),
    };
  },
  watch: {
    // 监听主应用自己的路由，仅当路由发生变化并且是主应用内部路由时触发
    "$route.path": {
      async handler(path) {
        // 让主应用包容所有可能的子应用路由，或者只要不在主应用自己的核心路由里，就保持显示微应用
        const isMainAppRoute = path === "/ai_home" || path === "/topic-assistant" || path === "/oauth_loading" || path === "/casiLoading" || path === "/Contact" || path === "/topic_assistant_result" || path === "/topic_assistant_result_ifram" || path === "/full_txt_art_analysis_result";
        if (isMainAppRoute) {
          this.showMicroApp = false;
          this.appLock = this.appLock.then(async () => {
            if (this.microAppInstance) {
              try {
                if (this.microAppInstance.mountPromise) {
                  await this.microAppInstance.mountPromise;
                }
                await this.microAppInstance.unmount();
                this.microAppInstance = null;
                this.activeAppName = "";
              } catch (e) {
                console.error("[主应用] 路由切换时卸载微应用失败:", e);
              }
            }
          });
        }
      },
      // 不要用 immediate: true，避免在刷新或者初始化时主应用抢夺路由控制权导致问题
      // immediate: true,
    },
  },
  computed: {
    // 计算当前是否为 oauth_loading 页面
    isOauthLoading() {
      return this.$route.name === "oauth_loading" || this.$route.path === "/oauth_loading";
    },
  },
  mounted() {
    // 监听子应用或者主应用内部触发的 token_updated 事件
    window.addEventListener("message", this.handleTokenUpdatedMessage);

    // 页面加载时手动检查一次
    this.checkAndLoadApp(window.location.pathname);

    // 监听原生的 popstate 和 hashchange 事件（覆盖所有的路由变化）
    window.addEventListener("popstate", this.handleNativeRoute);
    window.addEventListener("hashchange", this.handleNativeRoute);
  },
  beforeDestroy() {
    window.removeEventListener("message", this.handleTokenUpdatedMessage);
    window.removeEventListener("popstate", this.handleNativeRoute);
    window.removeEventListener("hashchange", this.handleNativeRoute);
  },
  methods: {
    getCurrentFullRoute() {
      return `${window.location.pathname}${window.location.search || ""}${window.location.hash || ""}`;
    },
    resetMicroAppScrollTop(path) {
      const targetPath = sessionStorage.getItem("chongda_menu_scroll_to_top_once");
      if (targetPath !== path) {
        return;
      }
      const applyScrollTop = () => {
        const container = document.getElementById("subapp-container");
        if (container) {
          container.scrollTop = 0;
        }
      };
      [0, 80, 180].forEach(delay => {
        setTimeout(applyScrollTop, delay);
      });
      sessionStorage.removeItem("chongda_menu_scroll_to_top_once");
    },
    shouldForceRefreshMicroToken(path) {
      return path === "/asp/self_setting";
    },
    async ensureMicroRouteTokenReady(path) {
      const leftBarRef = this.$refs.LeftBar_c;
      if (leftBarRef && typeof leftBarRef.ensureMicroAppTokenReady === "function") {
        await leftBarRef.ensureMicroAppTokenReady({
          forceRefresh: this.shouldForceRefreshMicroToken(path),
        });
      }
    },
    handleTokenUpdatedMessage(event) {
      if (event.data && event.data.type === "token_updated") {
        // 当 token 更新完毕后，如果有未完成的挂载任务，重新执行
        if (this.pendingLoadAppPath) {
          const pathToLoad = this.pendingLoadAppPath;
          this.pendingLoadAppPath = null;
          this.loadApp(pathToLoad);
        }
      }
    },
    handleNativeRoute() {
      // 避免重复触发加载逻辑
      if (this.pendingLoadAppPath === window.location.pathname) return;
      this.checkAndLoadApp(window.location.pathname);
    },
    async checkAndLoadApp(path) {
      const isMainAppRoute = path === "/ai_home" || path === "/topic-assistant" || path === "/oauth_loading" || path === "/casiLoading" || path === "/Contact" || path === "/topic_assistant_result" || path === "/topic_assistant_result_ifram" || path === "/full_txt_art_analysis_result";
      if (!isMainAppRoute) {
        await this.ensureMicroRouteTokenReady(path);
        // 如果 localStorage 中还没有 jyx_token，并且也没有标记为 tokenReady，才挂起等待
        if (!localStorage.getItem("jyx_token") && !window.tokenReady) {
          // 如果已经在等待该路径，不再重复打印和赋值
          if (this.pendingLoadAppPath !== path) {
            this.pendingLoadAppPath = path;
            this.showMicroApp = true; // 保持容器显示
          }
          return;
        }

        // 清理挂起状态并加载应用
        this.pendingLoadAppPath = null;
        this.showMicroApp = true;
        await this.loadApp(path);
        this.resetMicroAppScrollTop(path);
      } else {
        this.showMicroApp = false;
        this.appLock = this.appLock.then(async () => {
          if (this.microAppInstance) {
            try {
              if (this.microAppInstance.mountPromise) {
                await this.microAppInstance.mountPromise;
              }
              await this.microAppInstance.unmount();
              this.microAppInstance = null;
              this.activeAppName = "";
            } catch (e) {
              console.error("[主应用] 检查路由时卸载微应用失败:", e);
            }
          }
        });
      }
    },
    handleNavigateToMicro(app) {
      this.showMicroApp = true;
      this.currentMicroApp = app;
    },
    async loadApp(path) {
      this.appLock = this.appLock.then(async () => {
        let appName = "";
        let appEntry = "";
        const host = window.location.hostname;
        const isOnlineHost =
          host === "cxai.cxstar.cn" || host === "jyx.cxstar.cn";
        const isCxaiTest = host === "cxaitest.cxstar.cn";
        const isLocalDevHost =
          process.env.NODE_ENV === "development" &&
          ["localhost", "127.0.0.1", "192.168.0.39", "192.168.0.146"].includes(host);

        // 动态判断当前主应用环境来决定子应用的拉取地址，防止跨域拉取失败
        if (path.startsWith("/asp")) {
          appName = "ai_platform";
          if (isLocalDevHost) {
            appEntry = `http://${host}:8081`;
          } else if (isOnlineHost) {
            appEntry = "https://jyx.cxstar.cn/asp/";
          } else if (isCxaiTest) {
            appEntry = "/asp/";
          } else {
            appEntry = "https://cxaitest.cxstar.cn/asp/";
          }
        } else {
          appName = "chongda_web";
          if (isLocalDevHost) {
            appEntry = `http://${host}:8080`;
          } else if (isOnlineHost) {
            appEntry = "https://jyx.cxstar.cn";
          } else if (isCxaiTest) {
            appEntry = "/chongda_web/";
          } else {
            appEntry = "https://cxaitest.cxstar.cn";
          }
        }

        // 如果当前实例存在，并且正在挂载中，等待它挂载完成
        if (this.microAppInstance && this.microAppInstance.mountPromise) {
          try {
            await this.microAppInstance.mountPromise;
          } catch (e) {
            console.error(`[主应用] mountPromise 报错(可忽略):`, e);
          }
        }

        // 卸载不同的子应用，或者卸载处于非挂载状态的同名子应用（防止死锁）
        let shouldUnmount = false;
        if (this.microAppInstance) {
          if (this.activeAppName !== appName) {
            shouldUnmount = true;
          } else {
            // 虽然是同名子应用，但如果没有挂载成功，也强制卸载重新加载
            const status = this.microAppInstance.getStatus ? this.microAppInstance.getStatus() : null;
            if (status !== "MOUNTED") {
              shouldUnmount = true;
            }
          }
        }

        if (shouldUnmount) {
          try {
            await this.microAppInstance.unmount();
          } catch (e) {
            console.error(`[主应用] 卸载微应用 ${this.activeAppName} 失败:`, e);
          }
          this.microAppInstance = null;
          this.activeAppName = "";
          await new Promise(resolve => setTimeout(resolve, 100)); // 延长一点等待 DOM 清理
        }

        // 如果是同应用路由更新，且处于 MOUNTED 状态
        if (this.microAppInstance && this.activeAppName === appName) {
          try {
            if (this.microAppInstance.update) {
              await this.microAppInstance.update({ path: this.getCurrentFullRoute() });
            }
            this.resetMicroAppScrollTop(path);
          } catch (e) {
            console.error(`[主应用] update() 失败:`, e);
          }
          return;
        }

        // 挂载新应用
        if (!this.microAppInstance) {
          // 为了解决 Wrapper element is not existed 的问题，在重新挂载不同应用时，
          // 添加一个时间戳后缀，避免 qiankun 内部缓存把销毁的旧容器当成新容器
          const uniqueAppName = `${appName}_${Date.now()}`;
          this.activeAppName = appName;

          // 每次挂载前，确保容器 DOM 存在且是干净的
          const container = document.getElementById("subapp-container");
          if (container) {
            container.innerHTML = "";
          }

          try {
            this.microAppInstance = loadMicroApp({
              name: uniqueAppName,
              entry: appEntry,
              container: "#subapp-container",
              props: {
                loginWithHost: () => this.$refs.LeftBar_c.authUtils.getOrgUrl().then(url => {
                  window.location.href = url;
                }),
                getInitialRoute: () => this.getCurrentFullRoute(),
                getMicroToken: () => localStorage.getItem("jyx_token"),
                refreshMicroToken: () => {
                  const leftBarRef = this.$refs.LeftBar_c;
                  if (leftBarRef && typeof leftBarRef.refreshToken === "function") {
                    return leftBarRef.refreshToken();
                  }
                  return Promise.resolve(localStorage.getItem("jyx_token"));
                },
              },
            });
            this.microAppInstance.mountPromise.then(() => {
              this.resetMicroAppScrollTop(path);
            });

            this.microAppInstance.mountPromise.catch(err => {
              console.error(`[主应用] 子应用 ${appName} 挂载失败!`, err);
            });
          } catch (e) {
            console.error(`[主应用] loadMicroApp 执行异常:`, e);
          }
        }
      });
    },
  },
  // components: {
  //   HelloWorld
  // }
  // mounted() {

  // },
  // methods: {
  //   get_state() {

  //   }
  // }
};
</script>

<style lang="scss">
html,
body {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
}
#app {
  display: flex;
  align-items: flex-start;
  width: 100%;
  height: 100vh;
  overflow: hidden; /* 防止外层出现滚动条 */
}
.app-shell {
  display: flex;
  flex-direction: column;
  flex: 1;
  position: relative;
  min-width: 0;
  height: 100%;
}
.app-main {
  display: flex;
  flex: 1 1 auto;
  min-width: 0;
  min-height: 0;
  overflow: hidden;
}
.micro-app-container {
  flex: 1;
  height: 100%;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  width: 0; /* flex: 1 配合 width: 0 保证自适应铺满不被撑破 */
}
.view {
  flex: 1;
  height: 100%;
  overflow: hidden;
  -webkit-overflow-scrolling: touch;
  width: 0; /* 同样保证原生路由组件也能正确自适应 */
}
/* fade */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.28s;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}

/* fade-transform */
.fade-transform-leave-active,
.fade-transform-enter-active {
  transition: all 0.5s;
}

.fade-transform-enter {
  opacity: 0;
  transform: translateX(-100px);
}
.fade-transform-leave-to {
  opacity: 0;
  transform: translateX(100px);
}
.site-footer {
  flex: 0 0 auto;
  z-index: 20;
  padding: 8px 16px;
  color: #64748b;
  background: #f7f9fc;
  font-size: 12px;
  line-height: 18px;
  text-align: center;
  pointer-events: none;
}
.line1 {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
